var map = {
	"./AzureMaintenance.png": 410,
	"./AzurePolicy.png": 4337,
	"./Default-Profile-Picture.png": 4628,
	"./Defender.png": 2833,
	"./Exchange.png": 159,
	"./Forms.png": 9579,
	"./Intune.png": 6132,
	"./M365Admin.png": 906,
	"./Microsoft-Azure-Emblem.png": 817,
	"./Microsoft_logo.png": 2290,
	"./Monitoring_Reporting.png": 9813,
	"./Planner.png": 4262,
	"./Purview.png": 6408,
	"./Sharepoint.png": 6869,
	"./Teams.png": 2424,
	"./UniversalPrint.png": 360,
	"./default.png": 4741,
	"./default_old.png": 3235,
	"./entra.png": 7886,
	"./logo.png": 3153,
	"./netskope.jpg": 7227,
	"./optionsTechnology-logo.svg": 4050,
	"./packagemanagement.png": 7503,
	"./security_compliance.png": 3370,
	"./wide-white.png": 6973
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7909;